(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[37486,65250],{

/***/ 37486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ContentIntelligenceWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/styles/variables/compareCRMPricesVariables.module.scss
var compareCRMPricesVariables_module = __webpack_require__(31754);
var compareCRMPricesVariables_module_default = /*#__PURE__*/__webpack_require__.n(compareCRMPricesVariables_module);
;// CONCATENATED MODULE: ./src/components/contentintelligence/logo/index.tsx


function ContentintellIgenceLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "446",
        height: "53",
        fill: "none",
        viewBox: "0 0 446 53",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_231_5216)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#DF8D46",
                        d: "M67.835 42.42a16.861 16.861 0 01-17.22-17.32 16.689 16.689 0 014.913-12.307 16.505 16.505 0 0112.307-4.997 15.32 15.32 0 0112.18 5.482l-3.056 2.856a11.294 11.294 0 00-9.124-4.283 12.492 12.492 0 00-9.21 3.698 12.851 12.851 0 00-3.654 9.538 12.85 12.85 0 003.655 9.609 12.493 12.493 0 009.21 3.698 12.98 12.98 0 009.994-4.855l3.098 3.013a16.091 16.091 0 01-5.711 4.369 17.748 17.748 0 01-7.382 1.5zM83.027 30.327a11.965 11.965 0 013.284-8.653 11.179 11.179 0 018.381-3.427 11.038 11.038 0 018.324 3.427 11.896 11.896 0 013.341 8.653 11.811 11.811 0 01-3.341 8.652 11.025 11.025 0 01-8.324 3.427 11.18 11.18 0 01-8.381-3.427 11.979 11.979 0 01-3.284-8.652zm4.284 0a8.31 8.31 0 002.041 5.925 7.269 7.269 0 0010.552 0 8.24 8.24 0 002.127-5.925 8.195 8.195 0 00-2.127-5.869 7.138 7.138 0 00-10.552 0 8.252 8.252 0 00-2.07 5.869h.029zM109.77 18.99h4.083v3.155h.186a7.536 7.536 0 012.984-2.855 8.566 8.566 0 014.183-1.114 8.4 8.4 0 016.411 2.385 9.523 9.523 0 012.242 6.782V41.62h-4.284V27.7c-.085-3.713-1.956-5.555-5.597-5.555a5.312 5.312 0 00-4.283 2.056 7.438 7.438 0 00-1.713 4.926v12.55h-4.284l.072-22.687zM142.681 42.049a6.453 6.453 0 01-4.597-1.713 6.326 6.326 0 01-1.871-4.77V22.889h-4.026V18.99h3.983v-6.94h4.284v6.94h5.554v3.898h-5.54v11.294a4.17 4.17 0 00.871 3.07 2.856 2.856 0 001.999.813c.332 0 .662-.039.985-.114.311-.08.616-.18.914-.3l1.342 3.798a11.52 11.52 0 01-3.898.6zM160.043 42.42a10.853 10.853 0 01-8.238-3.427 12.123 12.123 0 01-3.242-8.666 12.31 12.31 0 013.156-8.567 11.295 11.295 0 0116.077-.186 13.006 13.006 0 012.984 9.138v.471h-17.862a7.354 7.354 0 002.228 5.369 7.133 7.133 0 006.235 1.912 7.138 7.138 0 005.187-3.954l3.784 1.856a11.224 11.224 0 01-4.284 4.484 11.708 11.708 0 01-6.025 1.57zm-6.796-14.863h13.007a5.712 5.712 0 00-1.928-3.912 6.75 6.75 0 00-4.654-1.543 6.185 6.185 0 00-4.141 1.428 7.141 7.141 0 00-2.284 4.027zM174.678 18.99h4.069v3.155h.186a7.536 7.536 0 012.984-2.855 8.566 8.566 0 014.183-1.114 8.397 8.397 0 016.411 2.385 9.534 9.534 0 012.256 6.782V41.62h-4.283V27.7c-.086-3.713-1.956-5.555-5.597-5.555a5.313 5.313 0 00-4.284 2.056 7.443 7.443 0 00-1.713 4.926v12.55h-4.283l.071-22.687zM207.589 42.049a6.467 6.467 0 01-4.612-1.713 6.388 6.388 0 01-1.87-4.77V22.889h-3.984V18.99h3.984v-6.94h4.283v6.94h5.554v3.898h-5.554v11.294a4.092 4.092 0 00.885 3.07c.531.518 1.243.81 1.985.813a4.66 4.66 0 00.999-.114c.306-.083.606-.183.9-.3l1.342 3.798a11.49 11.49 0 01-3.912.6z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#51378E",
                        d: "M223.695 41.678h-4.284V8.538h4.284v33.14zM229.62 18.99h4.069v3.155h.186a7.536 7.536 0 012.984-2.855 8.566 8.566 0 014.183-1.114 8.369 8.369 0 016.411 2.384 9.534 9.534 0 012.256 6.782v14.279h-4.283V27.698c-.086-3.712-1.956-5.554-5.597-5.554a5.314 5.314 0 00-4.284 2.056 7.443 7.443 0 00-1.713 4.926v12.55h-4.283l.071-22.687zM262.531 42.049a6.469 6.469 0 01-4.612-1.713 6.373 6.373 0 01-1.87-4.769v-12.68h-3.927V18.99h3.984v-6.94h4.283v6.94h5.554v3.898h-5.554v11.294a4.142 4.142 0 00.886 3.07c.53.518 1.242.81 1.984.813.336-.002.672-.04 1-.114.305-.083.605-.183.899-.3l1.342 3.798a11.49 11.49 0 01-3.969.6zM279.879 42.42a10.861 10.861 0 01-8.239-3.427 12.126 12.126 0 01-3.241-8.666 12.31 12.31 0 013.156-8.567 11.295 11.295 0 0116.077-.186 13.006 13.006 0 012.984 9.138v.471h-17.862a7.348 7.348 0 002.213 5.311 7.143 7.143 0 009.307.563 7.146 7.146 0 002.116-2.604l3.798 1.856a11.422 11.422 0 01-4.284 4.483 11.705 11.705 0 01-6.025 1.628zm-6.796-14.863h13.007a5.712 5.712 0 00-1.928-3.912 6.738 6.738 0 00-4.654-1.543 6.183 6.183 0 00-4.141 1.428 7.136 7.136 0 00-2.284 4.027zM308.949 8.538v33.14h-4.284V8.537h4.284zM299.473 8.538v33.14h-4.283V8.537h4.283zM319.644 11.166a2.851 2.851 0 01-.885 2.127 3.008 3.008 0 01-2.142.9 3 3 0 01-2.142-.9 3.033 3.033 0 010-4.283 3.03 3.03 0 014.284 0 2.858 2.858 0 01.885 2.156zm-.885 7.824v22.688h-4.284V18.99h4.284zM334.135 52.415a12.528 12.528 0 01-3.569-.486 11.41 11.41 0 01-3.027-1.428 9.681 9.681 0 01-2.342-2.084 8.98 8.98 0 01-1.428-2.684l4.027-1.6a6.45 6.45 0 002.413 3.184 6.78 6.78 0 003.983 1.214 7.052 7.052 0 005.412-2.084 8.098 8.098 0 001.942-5.712v-2.213h-.186a8.343 8.343 0 01-3.255 2.856 10.124 10.124 0 01-12.165-2.399 12.61 12.61 0 01-3.156-8.567 12.368 12.368 0 013.156-8.567 9.995 9.995 0 0112.107-2.484 8.34 8.34 0 013.256 2.856h.185V18.99h4.07v21.717a11.517 11.517 0 01-3.099 8.567 11.251 11.251 0 01-8.324 3.14zm.129-13.893a6.527 6.527 0 005.14-2.27 8.332 8.332 0 002.084-5.925 8.393 8.393 0 00-2.084-5.869 6.56 6.56 0 00-5.14-2.313 6.628 6.628 0 00-5.126 2.313 8.394 8.394 0 00-2.085 5.869 8.309 8.309 0 002.085 5.882 6.62 6.62 0 005.126 2.313zM360.707 42.42a10.819 10.819 0 01-8.238-3.427 12.079 12.079 0 01-3.255-8.667 12.293 12.293 0 013.141-8.566 11.298 11.298 0 018.007-3.456 11.306 11.306 0 018.084 3.27 13.063 13.063 0 012.984 9.138v.471h-17.862a7.48 7.48 0 002.228 5.369 7.142 7.142 0 009.307.562 7.134 7.134 0 002.115-2.604l3.798 1.856a11.263 11.263 0 01-4.283 4.483 11.623 11.623 0 01-6.026 1.57zm-6.81-14.864h13.007a5.712 5.712 0 00-1.984-3.869 6.726 6.726 0 00-4.641-1.542 6.152 6.152 0 00-4.14 1.428 7.135 7.135 0 00-2.242 3.983zM375.328 18.99h4.069v3.155h.186a7.635 7.635 0 012.984-2.855 8.566 8.566 0 014.198-1.114 8.407 8.407 0 016.41 2.385 9.523 9.523 0 012.242 6.782V41.62h-4.283V27.7c-.1-3.713-1.971-5.555-5.612-5.555a5.341 5.341 0 00-4.283 2.057 7.438 7.438 0 00-1.713 4.925v12.55h-4.284l.086-22.687zM410.78 42.42a11.177 11.177 0 01-8.367-3.427 12.224 12.224 0 01-3.227-8.666 11.982 11.982 0 013.298-8.653 11.187 11.187 0 018.367-3.427 10.668 10.668 0 016.069 1.742 10.555 10.555 0 013.883 4.784L416.92 26.4a6.382 6.382 0 00-6.34-4.283 6.57 6.57 0 00-5.04 2.356 9.196 9.196 0 000 11.665 6.56 6.56 0 005.04 2.356 6.653 6.653 0 006.568-4.284l3.798 1.628a10.181 10.181 0 01-3.912 4.783 11.04 11.04 0 01-6.254 1.8zM434.525 42.42a10.848 10.848 0 01-8.21-3.44 12.122 12.122 0 01-3.241-8.667 12.31 12.31 0 013.155-8.567 11.296 11.296 0 0116.077-.186 13.007 13.007 0 012.985 9.138v.471H427.4a7.353 7.353 0 002.228 5.369 7.135 7.135 0 009.306.562 7.136 7.136 0 002.116-2.604l3.798 1.856a11.427 11.427 0 01-4.283 4.484 11.711 11.711 0 01-6.04 1.584zm-6.782-14.863h13.007a5.715 5.715 0 00-1.927-3.912 6.74 6.74 0 00-4.655-1.542 6.185 6.185 0 00-4.141 1.427 7.141 7.141 0 00-2.284 4.027z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint0_linear_231_5216)",
                        d: "M3.955 33.71V3.67h26.757l5.697 5.254v24.815l-32.454-.028z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#51378E",
                        d: "M1.97 1.985v15.863H.014V0h25.7v1.985H1.97z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#DF8D46",
                        d: "M5.954 35.695V29.77h5.925v5.925H5.954zM15.877 27.785h5.926v5.94h-5.926v-5.94zM27.785 27.785h3.94v3.955h-3.769c-.157 0-.242 0-.242-.214v-3.612a.526.526 0 01.071-.129z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F1C19C",
                        d: "M25.786 39.664v-3.926h3.955v3.926h-3.955zM13.864 43.634h-3.94v-3.926h3.94v3.926z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F7DECD",
                        d: "M5.926 41.678v3.955H1.999v-3.955h3.927zM37.666 41.678v3.955h-3.927v-3.955h3.927zM19.818 49.588h-3.94v-3.955h3.94v3.955z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#51378E",
                        d: "M1.97 27.757H.014V19.86H1.97v7.896zM37.694 19.847h1.956v7.91h-1.956v-7.91z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F1C19C",
                        d: "M33.74 33.74h3.926v3.94h-3.927v-3.94zM21.803 37.709v3.926h-3.941v-3.926h3.94z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#51378E",
                        d: "M37.694 13.893h1.956v3.955h-1.956v-3.955zM1.97 29.77v3.955H0V29.77h1.97zM37.694 31.755V29.77h1.985v1.856s-.114.129-.172.129h-1.813zM.014 35.724h1.941v1.956H.014v-1.956zM39.664 11.251H28.428V0"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_231_5216",
                        x1: "20.189",
                        x2: "20.189",
                        y1: "6.782",
                        y2: "34.653",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#F7DECD"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E8F4F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_231_5216",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H445.262V52.401H0z"
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/contentIntelligenceWrapper.tsx









const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function ContentIntelligenceWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "CMS",
                    domain: "ContentIntelligence.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "CMS",
                    domain: "ContentIntelligence.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "TOP ENTERPRISE CONTENT MANAGEMENT COMPANIES",
                        textColor: (compareCRMPricesVariables_module_default()).offerCallNumber,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentintellIgenceLogo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 31754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColor":"#16556d","primaryColor":"#005670","green":"#5bc1a4","whyUsTitle":"#2e2e2e","whyUsItemTitle":"#005670","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453"};

/***/ })

}]);